<template>
  <div id="return-good">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý ', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="breceipt" class="soft-control">
        <div class="p-2">
          <b-row>
            <b-col>
              <base-input v-model="listQuery.search" label="Phiếu sản xuất " placeholder="Nhập mã phiếu sản xuất">
              </base-input>
              <b-button @click="handleSearch" variant="info">Kiểm tra</b-button>
            </b-col>
          </b-row>
        </div>
        <div class="row p-1">
          <div class="col-md-12">
            <soft-table
              @rowSelected="tbSetRowSelected"
              @rowClicked="tbRowClicked"
              class="table align-items-center table-flush"
              tbody-classes="list"
              :pending="false"
              :dataTable="tableData"
              :fields="fields"
              :minHeight="$hControl"
              @contextMenuItemClick="tbHandleContextMenuItemClick"
              ref="soft-table"
            >
              <template v-slot:cell(code)="row">
                <b-button @click="row.toggleDetails" variant="link">
                  {{ row.value }}
                </b-button>
              </template>
              <template v-slot:row-details="{ item }">
                <div class="py-2" style="background:#fff">
                  <b-row align-h="center" class="mx-0 mb-2">
                    <b-button
                      v-if="!item.userVerify"
                      @click="verifyReceipt(item)"
                      variant="success"
                      class="mt-2"
                      size="sm"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i>
                      Đã xuất hàng
                    </b-button>
                    <!-- <b-button
                      @click="printReceipt(item)"
                      variant="primary"
                      class="mt-2"
                      size="sm"
                    >
                      <i class="fa fa-print" aria-hidden="true"></i>
                      In lại phiếu
                    </b-button> -->
                  </b-row>
                  <base-table :data="item.ReceiptBillDetails">
                    <template slot="columns">
                      <th>STT</th>
                      <th>Mã Đơn hàng</th>
                      <th>Mã sản phẩm</th>
                      <th>Tên sản phẩm</th>
                      <th>Quy cách</th>
                      <th>Màu sắc</th>
                      <th>Mã màu 1</th>
                      <th>Số lượng hàng đặt</th>
                      <th>Số hàng đã trả</th>
                      <th>ĐVT</th>
                      <td></td>
                    </template>

                    <template slot-scope="{ row, index }">
                      <tr :key="index">
                        <td class="bg-info text-light col-fix ">
                          {{ index + 1 }}
                        </td>
                        <td>{{ row.order.code }}</td>
                        <td class="text-center">
                          {{ row.productInfo.product.code }}
                        </td>
                        <td class="text-center">
                          {{ row.productInfo.product.name }}
                        </td>
                        <td class="text-center">{{ row.productInfo.productSpecify.name }} mm</td>
                        <td class="text-center">
                          {{ row.productInfo.color.label }}
                        </td>
                        <td class="text-center">
                          {{ row.colorCode1 }}
                        </td>

                        <td class="text-center">
                          {{ $formatNumber(row.quantity) }}
                        </td>
                        <td class="text-center">
                          {{ $formatNumber(row.countReturnQuantity) }}
                        </td>
                        <td class="text-center">
                          {{ row.unit }}
                        </td>
                        <td>
                          <b-button @click="returnGood(item, row)" variant="danger">Trả hàng</b-button>
                        </td>
                      </tr>
                    </template>
                  </base-table>
                </div>
              </template>
              <template v-slot:cell(customer)="{ value }">
                <strong>{{ value.code }}</strong> <br />
                <span>{{ value.name }}</span>
              </template>
              <template v-slot:cell(userCreate)="{ value }">
                <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
              </template>
              <template v-slot:cell(userVerify)="{ value }">
                <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa được duyệt
                </span>
              </template>
              <template v-slot:cell(userManage)="{ value }">
                <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
                <span v-else class="badge badge-danger">
                  Chưa có người hỗ trợ
                </span>
              </template>
              <template>
                <pagination
                  class="mr-2 my-1"
                  slot="footer"
                  :total="listQuery.total"
                  :perPage="listQuery.limit"
                  @change="pagChange"
                />
              </template>
            </soft-table>
          </div>
        </div>
      </block>
      <ReturnModal ref="returnModal" @change="changeReturn"></ReturnModal>
    </div>
  </div>
</template>
<script>
import { receiptService } from '@/_services';
import ReturnModal from './__ReturnModal';
export default {
  name: 'return-good',
  components: {
    ReturnModal
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        search: ''
      },
      lastIndexCustomerSelected: 0,
      info: {},
      tableData: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'code',
          label: 'Mã phiếu',
          sortable: true
        },
        {
          tdClass: 'text-left',
          key: 'customer',
          label: 'Người Đặt hàng',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'Người tạo',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userVerify',
          label: 'Người duyệt hồ sơ',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'dateCreated',
          sortable: true,
          label: 'Ngày tạo'
        },
        {
          tdClass: 'text-center',
          key: 'dateUpdated',
          sortable: true,
          label: 'Lần cuối sửa đổi'
        }
      ]
    };
  },
  created() {},
  methods: {
    fetchData() {
      this.pending = true;
      this.$refs.breceipt.block();
      receiptService
        .findAllOutWithCode(this.listQuery)
        .then(res => {
          this.$refs.breceipt.unBlock();

          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            const receiptBill = data[i];
            for (let j = 0; j < receiptBill.ReceiptBillDetails.length; j++) {
              const ReceiptBillDetail = receiptBill.ReceiptBillDetails[j];
              let ReceiptBillReturn = ReceiptBillDetail.receiptBillReturn;
              let countReturnQuantity = 0;
              if (ReceiptBillReturn) {
                for (let k = 0; k < ReceiptBillReturn.length; k++) {
                  const element = ReceiptBillReturn[k];
                  countReturnQuantity += element.quantity;
                }
              }
              ReceiptBillDetail.countReturnQuantity = countReturnQuantity;
            }
          }
          this.tableData = data;
          this.listQuery.total = res.data.total;
          this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    returnGood(receipt, item) {
      this.$refs.returnModal.visible = true;
      this.$refs.returnModal.setData(receipt, item);
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    changeReturn() {
      this.fetchData();
    },
    handleSearch() {
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    }
  }
};
</script>
<style lang="scss"></style>
